<template>
	<div class='knd-icon knd-svg-icon knd-icon-play' >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
          <circle cx="10.5" cy="10.5" r="10.5" fill="url(#paint0_linear_332_524)"/>

          <g v-if="state === STATES.PLAY">
              <path d="M7.875 5.25L7.875 15.75L17.0625 10.5" fill="white"/>
          </g>
         
          <g v-if="state === STATES.PAUSE">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5625 5.25H9.1875V15.75H6.5625V5.25ZM11.8125 5.25H14.4375V15.75H11.8125V5.25Z" fill="white"/>
          </g>

          <defs>
            <linearGradient id="paint0_linear_332_524" x1="9.16177" y1="-2.14978e-07" x2="19.108" y2="20.1475" gradientUnits="userSpaceOnUse">
            <stop stop-color="#4D00FF"/>
            <stop offset="1" stop-color="#28006D"/>
            </linearGradient>
          </defs>

    </svg>
	</div>
</template>

<script>

export default {
  props: ['state'],
  setup () {
    let STATES = {
      PLAY: 'play',
      PAUSE: 'pause',
      REWIND: 'rewind'
    }

    return {
      STATES
    }
  }
}
</script>


<style lang="scss">
.knd-icon-play {
	width: 30px;
	height: 30px;
}

</style>